Drupal.behaviors.additionalFilterToggle = {
  attach: function (context, settings) {
    const filterToggle = document.querySelector("#showFilters");
    const additionalFilters = document.querySelector(".js-additional-filters");

    // Check if the additional filters element exists
    if (additionalFilters) {
      // Check local storage and apply the class if needed
      if (localStorage.getItem("additionalFiltersOpen") === "true") {
        additionalFilters.classList.add("additional-filters-open");
        filterToggle.setAttribute("aria-expanded", "true");
      } else {
        filterToggle.setAttribute("aria-expanded", "false");
      }

      filterToggle.addEventListener("click", function () {
        additionalFilters.classList.toggle("additional-filters-open");

        // Toggle the aria-expanded attribute
        const isExpanded = filterToggle.getAttribute("aria-expanded") === "true";
        filterToggle.setAttribute("aria-expanded", !isExpanded);

        // Save the state to local storage
        localStorage.setItem("additionalFiltersOpen", !isExpanded);
      });
    }
  },
};